import { supabase } from "./client";
import { withRequestDeadline } from "./requestDeadline";

const call = async (name, params) => {
  if (!supabase || !params.p_branch_id) throw new Error("No encontramos una sucursal activa.");
  const { data, error } = await withRequestDeadline(
    (signal) => supabase.rpc(name, params).abortSignal(signal),
    { timeoutMs: 10000, message: "La consulta de salones tardo demasiado. Actualiza para verificar el estado." }
  );
  if (error) throw new Error(error.message || "No se pudieron actualizar los accesos del salon.");
  if (data?.branchId !== params.p_branch_id || !Array.isArray(data.rooms) || !Array.isArray(data.qrs)) {
    throw new Error("No se pudo verificar el estado de los salones. Actualiza la lista.");
  }
  return data;
};

export const getBranchQrSalons = (branchId) => call("get_branch_qr_salons", { p_branch_id: branchId });
export const setBranchSalonQrAccess = (branchId, roomId, enabled, durationMinutes = 120) => {
  if (!roomId || typeof enabled !== "boolean") return Promise.reject(new Error("Selecciona un salon y una accion valida."));
  return call("set_branch_salon_qr_access", {
    p_branch_id: branchId, p_room_id: roomId, p_enabled: enabled,
    p_duration_minutes: Math.min(720, Math.max(30, Math.round(Number(durationMinutes) || 120))),
  });
};
